// extracted by mini-css-extract-plugin
export default {"header":"style_header__zAZ9o","emptyQuestionsView":"style_emptyQuestionsView__3IylX"};